module.exports = __webpack_public_path__ + "static/media/425.5cdf1880.png";